var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<h4 class=\"text-error text-center\">Votre accès à l'application timerecord.io a expiré.</h4>\n<br/>\n<h4 class=\"text-error text-center\">Veuillez nous contacter pour le renouveler.</h4>";
var id1="src/app/token-expired.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;